var map = {
	"./fb.svg": 5027,
	"./insta.svg": 3769,
	"./logo.svg": 1283,
	"./logo_black.svg": 1234,
	"./logo_footer.svg": 9842,
	"./play-filled.svg": 5746,
	"./warning.svg": 2461,
	"./yt.svg": 305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1265;